<template lang="pug">
.page-home-layout(:class="{ 'page-home-layout_hidden' : !visible }")
  markup-wrapper
    .top
      .presentation(v-if="$slots.presentation")
        slot(name="presentation")
      .form(v-if="$slots.search")
        slot(name="search")
    div(v-if="$slots.events")
      slot(name="events")
    .content(v-if="$slots.socials || $slots.default")
      .socials(v-if="$slots.socials")
        slot(name="socials")
      .text(v-if="$slots.default")
        slot
    .dashBoardSlot(v-if="$slots.dashboard")
      slot(name='dashboard')
</template>

<script>
import { WrapperPadded as MarkupWrapper } from '@/components/markup';

export default {
  components: {
    MarkupWrapper,
  },
  props: {
    visible: {
      type: Boolean,
      default: true,
    },
  },
};
</script>

<style lang="stylus">
@import '~@/stylus/helpers/mediaqueriesStep'

.page-home-layout
  opacity 1
  transition opacity .1s ease-in-out

  &_hidden
    opacity 0

  .content
    .text
      h1
        width 100%
        margin-top 0
        margin-bottom 29px
        padding-bottom 13px
        font-weight 300
        color: rgba(0, 0, 0, 0.85)
        border-bottom 1px solid #d3d4d9
        user-select text
        cursor text
        font-size 40px
        font-family 'Open Sans', sans-serif
        line-height 100%
      h2
        font-family 'Open Sans', sans-serif
        font-weight 700
        font-size 16px
        text-transform uppercase
        user-select text
        cursor text
      p
        margin-bottom 1em
</style>

<style lang="stylus" scoped>
@import '~@/stylus/helpers/mediaqueriesStep'
.dashBoardSlot
  padding-bottom 20px
.top
  position relative
  height 490px
  margin-bottom 40px
  border-radius .2em
  &:after
    content ""
    position absolute
    clear both
  +phone()
    display inline-block
    width 100%
    height auto

  $formWidthTablet = 33%
  $formWidthDesktop = 24.2%

  .form
    display block
    float left
    width 100%
    height 100%
    position relative
    box-sizing border-box
    +phone()
      margin-top 20px
    +tablet()
      width $formWidthTablet
    +desktop()
      width $formWidthDesktop

  .presentation
    display block
    float right
    margin 0
    width 100%
    height 100%
    +phone()
      width auto
      margin 0 -40px
      float none
    +tablet()
      width 100% - $formWidthTablet
    +desktop()
      width 100% - $formWidthDesktop

.content
  margin-top 40px
  &:after
    content ""
    position absolute
    clear both

  .text
    margin-bottom 45px
    padding 15px
    padding-top 0
    white-space pre-line
    word-break break-word
    background-color #fff
    margin-right 264px

  .socials
    width 254px
    float right
    padding-bottom 40px
    & > *
      margin-top 10px
      &:first-child
        margin-top 0
</style>



// WEBPACK FOOTER //
// Home.vue?7a8ba7cf